import { render, staticRenderFns } from "./LayoutEditor.vue?vue&type=template&id=4fd1eae8&scoped=true"
import script from "./LayoutEditor.vue?vue&type=script&lang=js"
export * from "./LayoutEditor.vue?vue&type=script&lang=js"
import style0 from "./LayoutEditor.vue?vue&type=style&index=0&id=4fd1eae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd1eae8",
  null
  
)

export default component.exports